<template>
  <div class="honor">
    <!-- 荣誉资质 -->
    <div v-for="(item, index) in allList" :key="item.cate_id">
      <h1>{{ item.title }}</h1>
      <div class="carousel">
        <span class="iconfont icon-houtui" @click="getOneList(false, index, item)"></span>
        <transition name="el-zoom-in-center">
          <div class="honor_zizhi_outer">
            <div class="honor_zizhi_inside">
              <div v-for="(img, sindex) in item.imgs" :key="sindex">
                <transition name="el-zoom-in-center">
                  <!-- v-for="(img, sindex) in item.imgs"
                  :key="sindex"-->
                  <el-image
                    v-if="item.imgShow"
                    fit="contain"
                    :src="img.image"
                    :preview-src-list="
                    imgs[index].map((i) => {
                      return i.image;
                    })
                  "
                  ></el-image>
                </transition>
              </div>
            </div>
          </div>
        </transition>

        <span class="iconfont icon-qianjin" @click="getOneList(true, index, item)"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Loading } from "element-ui";
let loading; //定义loading变量
function startLoading() {
  //使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: "loading……",
    background: "rgba(0, 0, 0, 0)",
  });
}
function endLoading() {
  //使用Element loading-close 方法
  loading.close();
}
export default {
  name: "honorG",
  data() {
    return {
      squreWidth: 0,
      moveMax: 0, //最大可移动距离
      params: [
        { limit: 3, page: 1 },
        { limit: 3, page: 1 },
      ], //点击按钮加page
      allList: [],
      imgs: [],
    };
  },
  computed: {
    ...mapGetters(["pageCate", "meanCenterObj"]),
    moveR() {
      return this.squreWidth == 0 ? false : true;
    }, //是否可移动
    moveL() {
      console.log(Math.abs(this.moveMax), Math.abs(this.squreWidth));
      return Math.abs(this.moveMax) < Math.abs(this.squreWidth) ? false : true;
    },
  },
  created() {
    this.getAllList();
  },
  methods: {
    getAllList() {
      startLoading();
      this.meanCenterObj._child.map((item) => {
        if (item.name == this.meanCenterObj.tabName && item._child) {
          item._child.map((sitem) => {
            this.$api.CATE(sitem.id, this.params[0]).then((res) => {
              this.$public_data
                .imageURL(res.list, this.params[0].limit)
                .then((imgs) => {
                  this.allList.push(...res.list);
                  this.imgs.push(res.list[0].images);
                  endLoading();
                });
            });
          });
        } else {
          endLoading();
        }
      });
    },
    getOneList(type, index, item) {
      let allList = this.allList;
      let page = this.params[index].page;
      let countPage = allList[index].countPage;
      let imgs = this.imgs[index];
      // 第一页和最后一页
      if (type) {
        // 下一页
        if (page > countPage - 1) {
          this.$message({
            type: "warning",
            message: "已经是最后页",
          });
          return;
        }
      } else {
        // 上一页
        if (page == 1) {
          this.$message({
            type: "warning",
            message: "已经是第一页",
          });
          return;
        }
      }
      startLoading();

      item.imgShow = false;
      this.params.splice(index, 1, {
        limit: 3,
        page: type
          ? (this.params[index].page += 1)
          : (this.params[index].page -= 1),
      });
      let newImgs = imgs.slice(
        (this.params[index].page - 1) * 3,
        this.params[index].page * 3
      );
      this.allList.splice(
        index,
        1,
        Object.assign(this.allList[index], { imgs: newImgs })
      );
      setTimeout(() => {
        item.imgShow = true;
        endLoading();
      }, 1000);
      // console.log(imgs, newImgs, "分页");
    },
  },
};
</script>

<style scoped lang='less'>
@keyframes move {
  50% {
    transform: translateY(100vh);
  }
  to {
    transform: translateY(0);
  }
}
.move {
  animation: move 1s;
}
//  荣誉资质
.honor {
  > div {
    > h1 {
      margin-bottom: 3.1vw;
    }
    > .carousel {
      display: flex;
      height: 11.46vw;
      justify-content: space-between;
      align-items: center;
      > span {
        min-width: 2.5vw;
        height: 5.625vw;
        line-height: 5.625vw;
        text-align: center;
        color: #fff;
        display: block;
        background: #dcdcdc;
      }
      > .honor_zizhi_outer {
        width: 54.6vw;
        .honor_zizhi_inside {
          min-width: 54.6vw;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-flow: row nowrap;
          height: 100%;
          overflow-x: hidden;
          > div {
            flex: 0 0 33%;
            height: 11.46vw;
            background: #f3f3f3;
            > div {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/go/honorG.vue